import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=63441a40&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"
import style0 from "./Item.vue?vue&type=style&index=0&id=63441a40&prod&scoped=true&lang=css"
import style1 from "./Item.vue?vue&type=style&index=1&id=63441a40&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63441a40",
  null
  
)

export default component.exports